<template>
  <BaseControlBar v-if="inputVal">
  <!-- <BaseControlBar :back-url="backUrl" v-if="inputVal"> -->
    <template v-if="role === 'admin'" class="flex-grow-1 d-flex">
      <div class="d-flex align-items-center flex-grow-1 section-header__title">
        <h1>{{ title }}</h1>
        <StatusLabel :item="status"></StatusLabel>
      </div>
      <template>
        <div class="admin-actions app--mobile-hidden">
            <ButtonApprove v-if="isPermit('APPROVE')"
                          @click="prepareAction('ACTIVATE')"
            >
              批准
            </ButtonApprove>
            <ButtonApprove v-if="isPermit('ACTIVATE')"
                          @click="prepareAction('ACTIVATE', '你已啓用這個用戶')"
            >
              啓動
            </ButtonApprove>
            <ButtonApprove v-if="isPermit('REAPPROVE')"
                          @click="prepareAction('ACTIVATE')"
            >
              重新批准
            </ButtonApprove>
            <ButtonReject v-if="isPermit('REJECT')"
                          @click="prepareAction('REJECT')"
            >
              拒絕
            </ButtonReject>
            <ButtonReject v-if="isPermit('DEACTIVATE')"
                          @click="prepareAction('DEACTIVATE', '你已停用這個用戶')"
            >
              停用
            </ButtonReject>
            <BaseButton v-if="isPermit('SHOW_COUPONS')"
                        variant="outline-secondary"
                        @click="viewMerchantCoupons"
            >
              此商戶優惠
            </BaseButton>
            <ButtonRemove v-if="isPermit('REMOVE')"
                          @click="prepareAction('REMOVE', '你已移除這個用戶')"
            >
              移除
            </ButtonRemove>
            <AdminActionConfirmModal v-model="approval"
                                    :onCouponStatusUpdate="onStatusUpdate$"
                                    :loading="loading"
            ></AdminActionConfirmModal>
            <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
          </div>
      </template>

    </template>

    <template v-if="role === 'merchant'">
      <h1>帳戶設定</h1>
    </template>

    <template v-slot:secondRow v-if="role === 'admin'">
      <!-- button-for-mobile start -->
      <template>
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview" v-if="isPermit('APPROVE')">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE')"
                  class="mobile-btn mobile-btn-green"
                >
                  批准
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('ACTIVATE')">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE', '你已啓用這個用戶')"
                  class="mobile-btn mobile-btn-green"
                >
                  啓動
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REAPPROVE')">
              <div class="right">
                <ButtonApprove
                  @click="prepareAction('ACTIVATE')"
                  class="mobile-btn mobile-btn-green"
                >
                  重新批准
                </ButtonApprove>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REJECT')">
              <div class="right">
                <ButtonReject
                  @click="prepareAction('REJECT')"
                  class="mobile-btn mobile-btn-red"
                >
                  拒絕
                </ButtonReject>
              </div>
            </div>
            <div class="overview" v-if="isPermit('DEACTIVATE')">
              <div class="right">
                <ButtonReject
                  @click="prepareAction('DEACTIVATE', '你已停用這個用戶')"
                  class="mobile-btn mobile-btn-red"
                >
                  停用
                </ButtonReject>
              </div>
            </div>
            <div class="overview" v-if="isPermit('SHOW_COUPONS')">
              <div class="right">
                <BaseButton
                  variant="outline-secondary"
                  @click="viewMerchantCoupons"
                  class="mobile-btn"
                >
                  此商戶優惠
                </BaseButton>
              </div>
            </div>
            <div class="overview" v-if="isPermit('REMOVE')">
              <div class="right">
                <ButtonRemove
                  @click="prepareAction('REMOVE', '你已移除這個用戶')"
                  class="mobile-btn"
                >
                  移除
                </ButtonRemove>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- button-for-mobile end -->
    </template>
  </BaseControlBar>
</template>

<script>
import { switchMap, tap } from 'rxjs/operators';
import { mapGetters } from 'vuex';
import http from '@/helpers/http';
import vModelMixin from '@/mixins/v-model';
import BaseButton from '@/components/BaseButton.vue';
import BaseControlBar from '@/components/BaseControlBar.vue';
import ButtonApprove from '@/components/button/ButtonApprove.vue';
import ButtonReject from '@/components/button/ButtonReject.vue';
import ButtonRemove from '@/components/button/ButtonRemove.vue';
import AdminActionConfirmModal from '@/components/coupon/AdminActionConfirmModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import getStatus from '@/helpers/status';
import StatusLabel from '@/components/StatusLabel.vue';

export default {
  mixins: [vModelMixin],
  props: {
    title: String,
  },
  components: {
    BaseButton,
    BaseControlBar,
    ButtonApprove,
    ButtonReject,
    ButtonRemove,
    AdminActionConfirmModal,
    ActionSuccessModal,
    StatusLabel,
  },
  data: () => ({
    availableActions: {
      PENDING: ['APPROVE', 'REJECT', 'REMOVE'],
      ACTIVATED: ['DEACTIVATE', 'SHOW_COUPONS', 'REMOVE'],
      INACTIVATED: ['ACTIVATE', 'SHOW_COUPONS', 'REMOVE'],
      REJECTED: ['REAPPROVE', 'REMOVE'],
    },
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/merchants',
        text: '返回商戶列表',
      },
    },
    loading: false,
  }),
  domStreams: ['onStatusUpdate$'],
  subscriptions() {
    return {
      listener$: this.onStatusUpdate$
        .pipe(
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => {
            const { action, remarks, msg } = this.approval;
            return http(
              {
                method: 'POST',
                url: `/agc-admin-api/merchants/${action.toLowerCase()}`,
                data: {
                  merchantId: this.inputVal.id,
                  remarks: remarks || '',
                },
              },
              {
                next: ({ status }) => {
                  this.inputVal.status = status;
                  if (msg) {
                    this.actionSuccessModal = {
                      ...this.actionSuccessModal,
                      show: true,
                      action,
                      msg,
                    };
                  }
                },
                complete: () => {
                  this.approval.modal = false;
                  this.loading = false;
                },
              },
            );
          }),
        ),
    };
  },
  methods: {
    prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
    isPermit(action) {
      const actions = this.availableActions[this.inputVal.status];
      if (!actions) return false;
      return actions.indexOf(action) >= 0;
    },
    viewMerchantCoupons() {
      this.$router.push({
        path: '/admin/coupons',
        query: {
          keywordType: 'merchantId',
          q: this.inputVal.id,
        },
      });
    },
  },
  computed: {
    ...mapGetters(['role']),
    backUrl() {
      return this.role === 'admin' ? '/admin/merchants' : null;
    },
    status() {
      return getStatus(this.inputVal);
    },
  },
};
</script>

<style scoped lang="scss">
.admin-actions {
  display: flex;
}

.coupon-overview-wrapper {
  background-color: #fff;
  width: 100%;
  display: inline-block;
  color: #fff;
  position: relative;
  margin-bottom: 10px;

  .overview-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .overview {
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: space-between;
      }
      .right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ccc;
      }
    }

    .overview:last-child {
      .right {
        border: 0px;
      }
    }
  }
}

@include respond(tab-landscape) {
  .app--mobile-shown {
    display: block !important;
  }

  .app--mobile-hidden {
    display: none !important;
  }

  .mobile-btn-grey {
    color: gray !important;
  }

  .mobile-btn-blue {
    color: #3596f4 !important;
  }

  .mobile-btn-green {
    color: green !important;
  }

  .mobile-btn-red {
    color: red !important;
  }
}

@include respond(tab-landscape) {
  .mobile-btn {
    flex-direction: column;
    background: none;
    border: none;
    color: gray;
  }
}
</style>
